import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
import APIS from '@/util/apis'
import channelMap from '@/util/channelIdMap.config'
import xinliceshiApp from '@/util/xinliceshiApp'

export function createStore () {
  return new Vuex.Store({
    state: {
      channelId: 513,
      topbarConfig: {
        show: true,
        back: true
        // borderColor,
        // title,
        // home, // 是否显示首页按钮
        // handlers: [{component}, {icon, text, route}]
      },
      userInfo: {
        userId: '',
        openId: '',
        unionId: '',
        userKey: '',
        platform_wx_openId: '',
        platform_wx_unionId: ''
      },
      vipInfo:'',
      vipPopWindow:{

      },
      showPopWindowStatus: false,
      // 用户个人信息，头像昵称之类的
      userPersonInfo: {},
      validUser:true
    },
    mutations: {
      setChannelId (state, channelId) {
        let map = channelMap.list
        if (map.includes(channelId * 1)) {
          state.channelId = channelId
        }
      },
      setTopbarConfig (state, config) {
        var _config

        if (config) {
          _config = Object.assign({}, state.topbarConfig, config)

          if (!config.handlers) {
            _config.handlers = null
          }
          Vue.set(state, 'topbarConfig', _config)
          // state.topbarConfig = _config;
        }
        console.log('topBar', state.topbarConfig)
      },
      userInfo (state, {userId, openId, unionId, userKey}) {
        state.userInfo.openId = openId
        state.userInfo.unionId = unionId
        if (!!userKey) {
          state.userInfo.userKey = userKey
        } else {
          state.userInfo.userId = userId
        }
      },
      userPersonInfo (state, {avatar, name}) {
        state.userPersonInfo.avatar = avatar
        state.userPersonInfo.name = name
      },
      vipInfo(state,config){
        state.vipInfo = config
      },
      setVipPopWindow(state, config){
        state.vipPopWindow = config;
        if (!!state.vipPopWindow.pop) {
          state.showPopWindowStatus = true
        }
      },
      setShowPopWindowStatus(state, config){
        state.showPopWindowStatus = config
      },
      setValidUser(state, config){
        // state.validUser = config
      }
    },
    actions: {
      getUserInfo ({commit, dispatch}, params) {

        return axios.get(`//m${APIS.env}.xinli001.com/ajax/get-user-header`, {params})
          .then(function ({data: res}) {
            let {code, data} = res
            if (+code === 0) {
              if (data.user) {
                commit('userPersonInfo', {
                  avatar: data.user.avatar,
                  name: data.user.nickname
                })
                // commit('userInfo', userInfo) 平台的userId等信息不记录
                // 当是口袋心理APP的时候，检测到有登录信息，写在这里是因为集中处理，不需要到处写这个逻辑
                xinliceshiApp.relaodWebView()
              } else {
                let userInfo = {
                  userId: '',
                  openId: '',
                  unionId: '',
                  userKey: ''
                }
                xinliceshiApp.removeReloadTag()
                commit('userInfo', userInfo)
              }
            }
            return res
          })
      },
      getUserKey (context, params) {
        return axios.get('/api/user/refreshUser', {params}).then(({data: res}) => {
          const {code, msg, data} = res
          if (+code === 1) {
            context.commit('userInfo', data)
            context.dispatch('fecthVipValidUser',{
              userKey:data.userKey
            })
            return res
          }
        })
      },
      fetchVipinfo({commit}, params) {
        return axios.get(`//m-lingxi${APIS.env}.xinli001.com/lingxi/service/vip/getVipInfo`, {
            params: params
        }).then(function(res) {
          console.log('vip状态信息',res.data)
          if (res.data.code == 1 && res.data.data) {
            commit('vipInfo', res.data.data);
            return res.data.data
          }
        })
      },
      // 会员弹窗接口
      fecthVipPopWindow(context, params) {
        return axios.get(`//m-lingxi${APIS.env}.xinli001.com/lingxi/service/vip/vipPopWindow`, {
          params: params
        }).then(function (res) {
          if (res.data.code == 1) {
            context.commit('setVipPopWindow', res.data.data);
            return res.data;
          }
        })
      },
      // 会员浮标
      fecthVipValidUser(context, params) {
        return axios.get(`//m-lingxi${APIS.env}.xinli001.com/lingxi/service/vip/validUser`, {
          params: params
        }).then(function (res) {
          if (res.data.code == 1) {
            context.commit('setValidUser', res.data.data);
            return res.data;
          }
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js